import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/loader';
import { StepHeading, StepShell } from '../../components/optionCard';
import { fetchInitialState, updateProducts } from './marginManagementSlice';
import { formatDollarWithComma } from '../utils';
import { nextStep, previousStep } from '../FormNavigator/navigatorSlice';



const MarginManagement = () => {
  const marginManagementState = useSelector((state) => state.margin_management);
  const navigatorState = useSelector((state) => state.navigator);
  const dispatch = useDispatch();
 
  const handleChange = (index, type, value) => {
    // Update the state with the new value for the specified index and type
    if (type === 'revenueCap') {
      let newValue = formatDollarWithComma(value);
      dispatch(updateProducts({ index, type, value: newValue }))
    }
    else {
      dispatch(updateProducts({ index, type, value }));
    }
  };

  useEffect(() => {
    dispatch(fetchInitialState()).then((res) => {      
      if (res.payload?.pl === "No") {
        // Check navigation direction and skip step accordingly
        if (navigatorState.navigationDirection === 'forward') {
          dispatch(nextStep());
        } else if (navigatorState.navigationDirection === 'backward') {
          dispatch(previousStep());
        }
      }
    });
  }, [dispatch, navigatorState.navigationDirection]);

  return (
    <>
    { marginManagementState.loading && <Loader /> }
    <StepShell>
        <StepHeading className="mb-2">
            Margin Management
        </StepHeading>
        <span className='mb-8 text-center text-sm text-slate-500 sm:mb-10 sm:text-base'>(Kindly take some time to specify your preferred margin settings)</span>

        {/* The three columns stay side by side; on a narrow screen the row scrolls
            sideways instead of squashing the inputs to nothing. */}
        <div className="profile-review-scrollbar -mx-1 w-full max-w-4xl overflow-x-auto px-1">
        <form className="mb-8 grid min-w-[560px] grid-cols-3 items-center gap-x-3 gap-y-4 sm:gap-4">
        <div className="text-left text-sm font-bold text-[#211b4f]">Product</div>
        <div className="flex items-center text-left text-sm font-bold text-[#211b4f]">
          <span className="mr-1 invisible" aria-hidden="true">%</span>
          <span>Margin</span>
        </div>
        <div className="text-left text-sm font-bold text-[#211b4f]">Revenue Caps</div>
        {(marginManagementState.data || []).map((product, index) => (
          <React.Fragment key={index}>
            <div className="text-sm text-slate-700">
              {product.name}
            </div>
            <div className="flex items-center">
              <span className="mr-1">%</span>
              <input
                min="0"
                type="number"
                className="number-input mt-1 block h-10 w-full rounded-lg border border-slate-300 p-2 text-sm shadow-sm focus:border-[#fb6635] focus:ring-[#fb6635]"
                value={product.margin}
                onChange={(e) => {
                  // Use the input directly from the event without conversion
                  let rawValue = e.target.value;
                  // if (rawValue === "0") rawValue = ""; // Remove leading zero
                  // Only update the state if the rawValue is not just leading zeros and decimal point
                  if (rawValue.match(/^\d*\.?\d*$/)) {
                      handleChange(index, 'margin', rawValue);
                  }
              }}
              onFocus={(e) => {
                if (e.target.value === "0") e.target.value = ""; // Clear field if initial value is zero
              }}
              onBlur={(e) => {
                  // On blur, clean up the value for any non-numerical content
                  let value = parseFloat(e.target.value);
                  value = isNaN(value) ? '' : value;  // Default to zero if the result is NaN
                  handleChange(index, 'margin', value.toString());
              }}
              />
            </div>
            <div className="flex items-center">
              <div className='flex items-center'>
                <label htmlFor={product.name} className="cursor-pointer">
                  <div className="relative">
                    <input
                      id={product.name}
                      type="checkbox"
                      className="sr-only"
                      checked={product.isRevenue || false}
                      onChange={(e) => handleChange(index, 'isRevenue', !product.isRevenue)}
                      tabIndex="-1" // Skip checkbox in tab order
                    />
                    <div className={`block h-6 w-11 rounded-full transition-colors ${product.isRevenue ? 'bg-[#fb6635]' : 'bg-slate-300'}`}></div>
                    <div
                      className={`dot absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
                        product.isRevenue ? 'translate-x-5' : ''
                      }`}
                    ></div>
                  </div>
                </label>
                <span className="ml-2 text-sm font-semibold text-slate-400">
                  { product.isRevenue ? '' : 'No'}
                </span>
              </div>
              {product.isRevenue && (
                <>
                <span className="mx-2">$</span>
                <input
                  type="text"
                  className="number-input mt-1 block h-10 w-full rounded-lg border border-slate-300 p-2 text-sm shadow-sm focus:border-[#fb6635] focus:ring-[#fb6635]"
                  value={product.revenueCap}
                  onChange={(e) => handleChange(index, 'revenueCap', e.target.value)}
                />
                </>)}
            </div>
          </React.Fragment>
        ))}
      </form>
      </div>
    </StepShell>
    </>
  )
}

export default MarginManagement;
